import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { SettingsService } from '../services/user/settings.service';
import { isFeatureEnabledInUserSettings, getUserActiveProducts } from '../../utils';

export const helpAccessGuard: CanActivateFn = () => {
  const settingsService = inject(SettingsService);
  const router = inject(Router);

  return settingsService.getUserSettings().pipe(
    map(settings => {
      const userActiveProducts = getUserActiveProducts();
      const isFAQEnabled = isFeatureEnabledInUserSettings(settings, 'Help', 'FAQ', userActiveProducts);
      const isGlossaryEnabled = isFeatureEnabledInUserSettings(settings, 'Help', 'Glossary', userActiveProducts);
      const isHelpEnabled = isFAQEnabled || isGlossaryEnabled;
      
      if (!isHelpEnabled) {
        // If Help is completely disabled in user settings, redirect to home page
        router.navigate(['/']);
        return false;
      }
      return true;
    })
  );
};
